import * as styled from '../styles/header';

type Props = {
  view: LandingV2.View;
  tone?: LandingV2.HeaderTone;
  onLogoClick: () => void;
  onSelectPro: () => void;
  onSelectCreator: () => void;
  onLogin: () => void;
  onSignUp: () => void;
};

export const Header = ({
  view,
  tone = 'default',
  onLogoClick,
  onSelectPro,
  onSelectCreator,
  onLogin,
  onSignUp,
}: Props) => (
  <styled.Shell $tone={tone}>
    <styled.Bar $tone={tone}>
      <styled.LogoGroup onClick={onLogoClick}>
        <styled.LogoMark $tone={tone}>K</styled.LogoMark>
        <styled.Wordmark $tone={tone}>kudable</styled.Wordmark>
      </styled.LogoGroup>
      <styled.RightGroup>
        {view !== 'choose' && (
          <styled.ChangePersonaLink onClick={onLogoClick}>
            ← Which one are you?
          </styled.ChangePersonaLink>
        )}
        <styled.TabSwitch $tone={tone}>
          <styled.Tab
            type="button"
            $tone={tone}
            $active={view === 'pro'}
            onClick={onSelectPro}
          >
            For pros
          </styled.Tab>
          <styled.Tab
            type="button"
            $tone={tone}
            $active={view === 'creator'}
            onClick={onSelectCreator}
          >
            For creators
          </styled.Tab>
        </styled.TabSwitch>
        <styled.LoginButton type="button" $tone={tone} onClick={onLogin}>
          Log in
        </styled.LoginButton>
        <styled.CtaButton type="button" $tone={tone} onClick={onSignUp}>
          Sign up
        </styled.CtaButton>
      </styled.RightGroup>
    </styled.Bar>
  </styled.Shell>
);
